module.exports = __webpack_public_path__ + "static/media/rebirth_4.3a73e4fb.jpg";